import {CanvasState} from '@catdetails/components/project-lopa-positions/canvas-state';
import {
  EntityBackedCanvasDrawable,
} from '@catdetails/components/project-lopa-positions/drawable/canvas-drawable';

export class Icon<T> implements EntityBackedCanvasDrawable<T> {
  private image: HTMLImageElement;
  private readonly hitMapColor: string;
  selected: boolean;
  public x = 0;
  public y = 0;

  constructor(public entity: T, private getBase64OrImage: (entity: T) => string | HTMLImageElement,
              public updateFromEntity: (icon: Icon<T>) => void,
              public updateEntity: (icon: Icon<T>) => void,
              public hasChanged: (icon: Icon<T>) => boolean) {
    this.hitMapColor = CanvasState.getNextHitMapColor(this);
    this.updateFromEntity(this);
    let base64OrImage = getBase64OrImage(entity);
    if (base64OrImage instanceof HTMLImageElement) {
      this.image = base64OrImage;
    } else {
      if (base64OrImage == null || base64OrImage === '') {
        base64OrImage = CanvasState.NO_IMAGE_PLACEHOLDER;
      }
      if (base64OrImage.startsWith('data:application/octet-stream')) {
        // TODO: Fix loading of octet stream encoded images - or check if they shouldn't be there in the first place...
        // const r = new FileReader();
        // r.onload = () => {
        //   const data = r.result.toString();
        //   this.loadImage(data);
        // };
        // // // r.readAsDataURL(new Blob([base64OrImage]));
        // // r.readAsDataURL(new Blob([base64OrImage], {type : 'image/png'}));
        // const blob = new Blob([base64OrImage.substr(base64OrImage.indexOf(',') + 1)]);
        // r.readAsDataURL(blob);
        // // base64OrImage = 'data:image/png;base64,' + URL.createObjectURL(blob);
        // // this.loadImage(base64OrImage);
        this.loadImage(CanvasState.NO_IMAGE_PLACEHOLDER);
      } else {
        this.loadImage(base64OrImage);
      }
    }
  }

  private loadImage(imgSrc: string) {
    const image = new Image();
    image.onload = () => {
      this.image = image;
    };
    image.src = imgSrc;
  }
  draw(context: CanvasRenderingContext2D, hitMapContext?: CanvasRenderingContext2D) {
    if (!this.image) {
      // nothing to draw
      return;
    }
    this.selected = false;
    context.drawImage(this.image, this.x - this.image.width / 2, this.y - this.image.height / 2);
    if (hitMapContext) {
      hitMapContext.fillStyle = this.hitMapColor;
      hitMapContext.fillRect(this.x - this.image.width / 2, this.y - this.image.height / 2, this.image.width, this.image.height);
    }
  }

  select(context: CanvasRenderingContext2D, selectionColor: string, selectionWidth: number): void {
    this.selected = true;
    context.strokeStyle = selectionColor;
    context.lineWidth = selectionWidth;
    context.strokeRect(this.x - this.image.width / 2, this.y - this.image.height / 2, this.image.width, this.image.height);
  }

  move(dx: number, dy: number) {
    this.x += dx;
    this.y += dy;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/components/project-lopa-positions/drawable/icon.ts